module.exports = __webpack_public_path__ + "img/thumbs-up-duotone.15d3f75a.svg";